import React, {Component} from 'react';

import styled from 'styled-components';
import lunchLogo from 'assets/images/logo-lunch-team.svg';
import './index.css';

const Overlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 1000;
  background-color: rgba(0, 0, 0, .65);
`;

const Content = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10000;
  overflow: auto;
  text-align: center;
  overflow-scrolling: touch;
  padding: 4px;
  cursor: pointer;

  &:after {
    vertical-align: middle;
    display: inline-block;
    height: 100%;
    margin-left: -.05em;
    content: '';
  }
`;

const Dialog = styled.div`
  position: relative;
  outline: 0;
  width: 100%;
  background: white;
  display: inline-block;
  vertical-align: middle;
  box-sizing: border-box;
  max-width: 480px;
  cursor: default;
  -moz-border-radius: 6px 6px 6px 6px;
  -webkit-border-radius: 6px;
  border-radius: 6px 6px 6px 6px;
`;

const Header = styled.div`
  padding: 16px 8px 8px 8px
`;

const Body = styled.div`
  padding-bottom: 16px
`;

export default class ModalConfirm extends Component {

   onOverlayClick = () => {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    onDialogClick = (event: Event) => {
        event.stopPropagation();
    }

    listenKeyboard(event: KeyboardEvent) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            this.props.onClose();
        }
    }

    componentDidMount() {
        if (this.props.onClose) {
            window.addEventListener('keydown', this.listenKeyboard.bind(this), true);
        }
    }

    componentWillUnmount() {
        if (this.props.onClose) {
            window.removeEventListener('keydown', this.listenKeyboard.bind(this), true);
        }
    }

    render(){
      return (<div>
                  <Overlay />
                  <Content onClick={this.onOverlayClick}>
                      <Dialog onClick={this.onDialogClick}>
                          <Header>
                              <a style={{cursor:'auto'}}>
                                  <img src={lunchLogo} alt="Lunch Team" />
                              </a>
                          </Header>
                          <Body>
                              {this.props.children}
                          </Body>
                            <div className="confirm-no-yes">
                              <a onClick={this.props.onClose} className="btn-cancel">No</a>
                              <a onClick={this.props.onConfirm} className="btn-confirm">Yes</a>
                            </div>
                      </Dialog>
                  </Content>
              </div>);
    }

}



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalConfirm/index.js